import React from "react"

function Family({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.1538 12.1334C12.2894 12.1334 13.21 11.2128 13.21 10.0772C13.21 8.9416 12.2894 8.02103 11.1538 8.02103C10.0182 8.02103 9.09766 8.9416 9.09766 10.0772C9.09766 11.2128 10.0182 12.1334 11.1538 12.1334Z"
        stroke="#003E4C"
        strokeWidth="0.993958"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9992 20.7898C18.8153 20.7898 19.4769 20.1282 19.4769 19.3121C19.4769 18.496 18.8153 17.8344 17.9992 17.8344C17.1831 17.8344 16.5215 18.496 16.5215 19.3121C16.5215 20.1282 17.1831 20.7898 17.9992 20.7898Z"
        stroke="#003E4C"
        strokeWidth="0.996267"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.41 21.4326C15.8068 24.4741 20.0343 24.4207 20.5393 21.4326"
        stroke="#003E4C"
        strokeWidth="1.00036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.7422 12.2134C25.8778 12.2134 26.7984 11.2928 26.7984 10.1572C26.7984 9.02161 25.8778 8.10103 24.7422 8.10103C23.6066 8.10103 22.686 9.02161 22.686 10.1572C22.686 11.2928 23.6066 12.2134 24.7422 12.2134Z"
        stroke="#003E4C"
        strokeWidth="0.993958"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.65546 22.114C7.65546 22.114 8.20361 15.9149 8.36243 14.0681C8.3912 13.7774 8.63653 13.5552 8.925 13.5552C9.9928 13.5552 12.4239 13.5552 13.4555 13.5552C13.7368 13.5552 13.9678 13.755 14.011 14.0277C14.2347 15.3854 14.8406 19.1973 14.8406 19.1973"
        stroke="#003E4C"
        strokeWidth="1.00036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3446 22.1133C28.3446 22.1133 27.7964 15.9142 27.6376 14.0674C27.6088 13.7766 27.3635 13.5544 27.075 13.5544C26.0072 13.5544 23.5761 13.5544 22.5445 13.5544C22.2632 13.5544 22.0322 13.7543 21.989 14.027C21.7653 15.3847 21.1594 19.1966 21.1594 19.1966"
        stroke="#003E4C"
        strokeWidth="1.00036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5332 21.7114V27.9791"
        stroke="#003E4C"
        strokeWidth="1.00036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0303 21.4307V27.6983"
        stroke="#003E4C"
        strokeWidth="1.00036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2072 25.1021V27.6965"
        stroke="#003E4C"
        strokeWidth="0.541513"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9692 21.7114V27.9791"
        stroke="#003E4C"
        strokeWidth="1.00036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.4659 21.4307V27.6983"
        stroke="#003E4C"
        strokeWidth="1.00036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6433 25.1021V27.6965"
        stroke="#003E4C"
        strokeWidth="0.541513"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Family
